import { CommissionsProcessingToolPanel } from "../CommissionsProcessingToolPanel";
import { Button, DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutCommissionsProcessingVoid extends Layout {
    buttonArchive: Button;
    layoutCommissionsProcessingToolPanel: CommissionsProcessingToolPanel;
    panelTaskFilters: Panel;
    sourceCommissionsProcessing: DataSource;
    tableCommissionsProcessing: Table;
}
